import { API_CORE } from "../../_CORE/API/ApiCORE";
import { REACT_HOT_TOAST_ERROR } from "../../_CORE/HELPERS/reactHotToast.helper";

/*
    Persistencia silenciosa para switches/estrellas.

    La UI se actualiza primero con mutateLocal/setState. Este helper hace una
    única petición PATCH para persistir: no prende loaders, no espera tiempos
    mínimos, no muestra toast de éxito y, sobre todo, no dispara un GET ni
    recarga la colección. Si falla, el caller revierte sólo el cambio local.
*/
export const onSilentPatch = async ({ endpoint, id = null, data = null, errorMessage = "No se pudo guardar el cambio." }) => {
    const resource = API_CORE.ENDPOINTS[endpoint];
    if (!resource) {
        REACT_HOT_TOAST_ERROR(errorMessage);
        return { success: false, data: null, message: "Endpoint inválido" };
    }

    try {
        const response = await API_CORE.SERVICES.PATCH_resource(resource, id, data);
        const errorBody = response?.data?.success === false ? response.data : null;
        const status = Number(
            response?.status
            ?? response?.code_status
            ?? response?.statusCode
            ?? errorBody?.status
            ?? errorBody?.code_status
            ?? (response?.success === true ? 200 : 0),
        );
        const success = response?.success === true
            || response?.ok === true
            || (status >= 200 && status < 300);

        const message = response?.message
            || errorBody?.message
            || response?.detail
            || errorBody?.detail
            || "";

        if (!success) REACT_HOT_TOAST_ERROR(message || errorMessage);

        return {
            success,
            data: errorBody ? (errorBody?.data ?? null) : (response?.data ?? null),
            message,
        };
    } catch (error) {
        const message = error?.response?.data?.message || error?.message || errorMessage;
        REACT_HOT_TOAST_ERROR(message);
        return { success: false, data: null, message };
    }
};
